var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSideNo1 = function SvgSideNo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sideNO_1_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sideNO_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC5E29",
    d: "M2 21.906a1 1 0 0 0 1.496.868l8.482-4.847a1 1 0 0 1 1.03.023l7.458 4.71A1 1 0 0 0 22 21.815V1.629a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.71 4.429v10.95h-2.7v-8.91H9.615v-2.04z"
  }))));
};
export default SvgSideNo1;